<div class="label">
    <span class="label-text">This webpage is under construction !</span>
</div>
<div class="main-img">
    <img class="img-content" src="assets/imgs/development.png" alt="">
</div>
<div class="label">
    <span class="label-text-2">Coming soon !</span>
</div>